import type { AgentTemplate, TemplateCategory } from "./types";
import { computed } from "vue";
import { locale } from "@/services/i18n";

// Templates EN
import { customerServiceTemplatesEN } from "./en/customer-service";
import { financialTemplatesEN } from "./en/financial";
import { healthcareTemplatesEN } from "./en/healthcare";
import { internalTemplatesEN } from "./en/internal";
import { salesTemplatesEN } from "./en/sales";
import { utilitiesTemplatesEN } from "./en/utilities";

// Templates PT
import { customerServiceTemplatesPT } from "./pt/customer-service";
import { financialTemplatesPT } from "./pt/financial";
import { healthcareTemplatesPT } from "./pt/healthcare";
import { internalTemplatesPT } from "./pt/internal";
import { salesTemplatesPT } from "./pt/sales";
import { utilitiesTemplatesPT } from "./pt/utilities";

const templatesEN: AgentTemplate[] = [
  ...customerServiceTemplatesEN,
  ...salesTemplatesEN,
  ...internalTemplatesEN,
  ...healthcareTemplatesEN,
  ...financialTemplatesEN,
  ...utilitiesTemplatesEN,
];

const templatesPT: AgentTemplate[] = [
  ...customerServiceTemplatesPT,
  ...salesTemplatesPT,
  ...internalTemplatesPT,
  ...healthcareTemplatesPT,
  ...financialTemplatesPT,
  ...utilitiesTemplatesPT,
];

/**
 * Hook para acessar templates baseado no idioma atual
 */
export function useTemplates() {
  const templates = computed<AgentTemplate[]>(() => {
    return locale.value === "pt" ? templatesPT : templatesEN;
  });

  const getTemplatesByCategory = (category: TemplateCategory) => {
    return computed(() => templates.value.filter((t) => t.category === category));
  };

  const getTemplateById = (id: string) => {
    return computed(() => templates.value.find((t) => t.id === id));
  };

  return {
    templates,
    getTemplatesByCategory,
    getTemplateById,
  };
}

export * from "./categories";
// Re-exports
export * from "./types";
